
export const isDev = false

export const REACT_APP_LIFERAY_HOST = isDev
  ? "https://bicici-dev.diginfactory.com"
  : window?.Liferay?.ThemeDisplay?.getPortalURL();

export const REACT_APP_CREDENTIALS = "aroun@diginfactory.com:thesecret" 
